// Snyk considers this an issue if hardcoded directly inside
// parlorConfig.apiToken (even though it's only used once)
window.PARLOR_API_TOKEN = 'ae3cdf52-393e-41f1-b555-075f5ff21ec6';
window.PARLOR_ORGANIZATION_ID = 'aceddff0-c059-424e-9539-de368e516d4a';

window.parativeConfig = {
  user: {
    uid: window.activeUser.id.toString(),
    email: window.activeUser.username,
    // deepcode ignore HardcodedNonCryptoSecret: They’re going to be public anyway because of the nature of FE’s
    apiToken: window.PARLOR_API_TOKEN,
    organizationID: window.PARLOR_ORGANIZATION_ID,
    lng: 'eng', // can be "eng" or "fr"
  },
};

/* eslint-disable */

!(function () {
  var e = window;
  if (!e.Parative) {
    var t = document,
      a = function () {
        var e = t.createElement('script');
        (e.type = 'text/javascript'),
          (e.async = !0),
          (e.src = 'https://widget.parative.com/latest/index.js');
        var a = t.getElementsByTagName('script')[0];
        a.parentNode.insertBefore(e, a);
      };
    'complete' === document.readyState
      ? a()
      : e.attachEvent
      ? e.attachEvent('onload', a)
      : e.addEventListener('load', a, !1);
  } else console.warn('Parative already loaded.');
})();

/* eslint-enable */
